import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import { Flex } from "@fluentui/react-northstar";
import ReportItem from "./reportItem";
import IReport from "../interfaces/IReport";
import { getFriendlyDateString } from "../common/dateOperations";
import { numberToString } from "../common/numberOperations";
import { useApp } from "../contexts/appContext";
import styles from "./reportGroup.module.scss";

export interface IReportGroupProps {
    items: IReport[];
}

const ReportGroup: React.FunctionComponent<IReportGroupProps> = ({ items }) => {
    const { state, dispatch } = useApp();
    const { reportsGroupped, color } = state;

    const durationHours = items.map((x: IReport) => x.durationInMinutes).reduce((a: number, b: number) => a + b) / 60;
    let durationString;

    if (durationHours < 1 || (durationHours > 1 && durationHours < 5)) {
        durationString = "hodiny";
    } else if (durationHours === 1) {
        durationString = "hodina";
    } else {
        durationString = "hodin";
    }

    const firstDate = items.length > 0 ? new Date(items[0].start) : new Date();

    const toggleGroup = () => {
        dispatch({ type: "SET_REPORTS_GROUPPED", groupped: !reportsGroupped });
    };

    const anchorId = `${firstDate.getMonth() + 1}-${firstDate.getDate()}`;

    return (
        <div className={styles.groupAnchor}>
            <span id={anchorId}></span>
            <Flex column>
                <Link to={`/#${anchorId}`} onClick={toggleGroup} style={{ color }} className={styles.groupHeader}>
                    <Flex>
                        <div>{getFriendlyDateString(firstDate)}</div>
                        <Flex.Item push>
                            <div>{numberToString(durationHours)} {durationString}</div>
                        </Flex.Item>
                    </Flex>
                </Link>
                {!reportsGroupped &&
                    <>{items.map((item: IReport) => <ReportItem key={item.id} {...item} />)}</>
                }
            </Flex>
        </div>
    );
};

export default ReportGroup;
